<datalist id="sf-objects-list">
  <option *ngFor="let typeItem of sfObjectsSuggestionList" [value]="typeItem"></option>
</datalist>

<datalist id="sf-object-fields-list">
  <option *ngFor="let metaItem of sfCurrObjMetaList" [value]="metaItem.name"></option>
</datalist>

<table class="pushback-table">
  <ng-container *ngIf="isNeedShowForm">
    <tr class="pushback-table-highlighted-row">
      <td colspan="2"><strong>Type:</strong></td>
    </tr>
    <tr>
      <td class="pushback-table-left-td">Enter Salesforce Record Type:</td>
      <td data-label="Select type">
        <input
          #selectType
          type="text"
          class="sn-sf-input full-width"
          (input)="onChangeSfObjectType(selectType.value)"
          value="{{ recordType.name }}"
          [(ngModel)]="recordType.name"
          placeholder="{{ type_placeholder }}"
          list="sf-objects-list"
          autocomplete="off"
          [disabled]="!isUserOwnerOfDocument"
        />
      </td>
    </tr>
    <tr>
      <td colspan="2"><br /></td>
    </tr>
    <tr class="pushback-table-highlighted-row">
      <td colspan="2"><strong>Fields:</strong></td>
    </tr>
    <ng-container *ngFor="let field of document.fields">
      <ng-container *ngIf="databindingService.isAllowedTypeOfDocumentField(field.type)">
        <tr>
          <td colspan="2" class="">
            <div class="flex-row">
              <div><strong>SignNow field type:</strong> {{ field.type }}</div>
              <div><strong>SignNow Role:</strong> {{ field.role }}</div>
              <div *ngIf="field.json_attributes?.name">
                <strong>Name:</strong> {{ field.json_attributes.name }}
              </div>
              <div *ngIf="field.json_attributes?.label">
                <strong>Label:</strong> {{ field.json_attributes.label }}
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="pushback-table-left-td">Enter Salesforce Record Field:</td>
          <td *ngIf="!sfCurrObjMetaList.length">
            <input
              type="text"
              class="sn-sf-input full-width"
              [id]="field.id"
              [attr.value]="field.integrations[0].field"
              [(ngModel)]="field.integrations[0].field"
              placeholder="SALESFORCE_FIELD_NAME"
              [disabled]="!isUserOwnerOfDocument"
            />
          </td>
          <td *ngIf="sfCurrObjMetaList.length" data-label="Select type">
            <div class="slds-truncate" title="Select type">
              <input
                type="text"
                class="sn-sf-input full-width select"
                [id]="field.id"
                [attr.value]="field.integrations[0].field"
                [(ngModel)]="field.integrations[0].field"
                (input)="onSfFieldChange(field)"
                list="sf-object-fields-list"
                autocomplete="off"
                placeholder="SALESFORCE_FIELD_NAME"
                [disabled]="!isUserOwnerOfDocument"
              />
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <label
              class="slds-form-element__label"
              [ngClass]="{ hidden: isFieldNotAvailabelForUpdate(field) }"
            >
              <input
                type="checkbox"
                name="updSfField"
                class="slds-checkbox"
                [(ngModel)]="field.isUpdateSfFieldFromDocument"
                [disabled]="!isUserOwnerOfDocument || !field.integrations[0].field"
              />
              <span>Update Salesforce record field</span>
            </label>
          </td>
          <td>
            <label
              *ngIf="databindingService.isAllowedTypeOfDocumentField(field.type)"
              class="slds-form-element__label"
            >
              <input
                type="checkbox"
                name="appendSfField"
                class="slds-checkbox"
                [(ngModel)]="field.isAppendSfFieldIntoSnField"
                [disabled]="!isUserOwnerOfDocument || !field.integrations[0].field"
              />
              <span>Append from Salesforce record field</span>
            </label>
          </td>
        </tr>

        <tr>
          <td colspan="2"><br /></td>
        </tr>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!isNeedShowForm">
    <tr>
      <td>
        <div #alterRef>
          <ng-content select=".sn-binding-alter-message"></ng-content>
        </div>
        <ng-container *ngIf="!alterRef.childNodes.length">
          Template doesn't contain fields.<br />
          Please add fields to the template on signnow.com before selecting this option.
        </ng-container>
      </td>
    </tr>
  </ng-container>
</table>
